import React from 'react';
import { Html } from '@react-three/drei';

const ModelLoadError = () => {
    return (
        <Html as='div' >
            <div
                style={{
                    transform: 'translateY(-150px)',
                    fontSize: '28px',
                    textAlign: 'center',
                }}
            >
                Error Loading 3D&nbsp;Model File
            </div>
        </Html>
    )
}

export default ModelLoadError;